import('./bootstrap').catch(error => console.error('Error on remote module', error))

export {}
